import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AddressAudit,
  ContactInfoSkeleton,
  EmailAddressAudit,
  PhoneNumberSkeleton,
  PhoneNumberAudit,
  AddressSkeleton,
  EmailAddressSkeleton
} from '../../+models/person-profile-audit.model';
import { PersonProfilePhoneNumberAuditListComponent } from '../person-profile-phone-number-audit-list/person-profile-phone-number-audit-list.component';
import { PersonProfileAddressAuditListComponent } from '../person-profile-address-audit-list/person-profile-address-audit-list.component';
import { PersonProfileEmailAddressAuditListComponent } from '../person-profile-email-address-audit-list/person-profile-email-address-audit-list.component';

@Component({
  selector: 'sd-portal-person-profile-contact-info-audit-list',
  templateUrl: './person-profile-contact-info-audit-list.component.html',
  styleUrls: ['./person-profile-contact-info-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileContactInfoAuditListComponent implements OnInit {
  @Input() contactInfo: ContactInfoSkeleton;

  @Input() addressAuditsLoading: boolean;
  @Input() addressAudits: AddressAudit[];

  @Input() phoneNumberAuditsLoading: boolean;
  @Input() phoneNumberAudits: PhoneNumberAudit[];

  @Input() emailAddressAuditsLoading: boolean;
  @Input() emailAddressAudits: EmailAddressAudit[];

  @Output() loadAddressAudits = new EventEmitter();
  @Output() nextAddressAuditPage = new EventEmitter();

  @Output() loadPhoneNumberAudits = new EventEmitter<number>();
  @Output() nextPhoneNumberAuditsPage = new EventEmitter<number>();

  @Output() loadEmailAddressAudits = new EventEmitter<number>();
  @Output() nextEmailAddressAuditsPage = new EventEmitter<number>();

  @ViewChildren(PersonProfileAddressAuditListComponent)
  personProfileAddressAuditLists: QueryList<PersonProfileAddressAuditListComponent>;
  @ViewChildren(PersonProfilePhoneNumberAuditListComponent)
  personProfilePhoneNumberAuditLists: QueryList<PersonProfilePhoneNumberAuditListComponent>;
  @ViewChildren(PersonProfileEmailAddressAuditListComponent)
  personProfileEmailAddressAuditLists: QueryList<PersonProfileEmailAddressAuditListComponent>;

  constructor() {}

  ngOnInit() {}

  addressOpened(address: AddressSkeleton) {
    setTimeout(() => {
      const match = this.personProfileAddressAuditLists.find(
        a => a.addressId === address.addressId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  phoneNumberOpened(phoneNumber: PhoneNumberSkeleton) {
    setTimeout(() => {
      const match = this.personProfilePhoneNumberAuditLists.find(
        p => p.phoneNumberId === phoneNumber.phoneNumberId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  emailAddressOpened(emailAddress: EmailAddressSkeleton) {
    setTimeout(() => {
      const match = this.personProfileEmailAddressAuditLists.find(
        e => e.emailAddressId === emailAddress.emailAddressId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }
}
